import React, { useEffect, useState } from 'react'
import { Box } from '@material-ui/core'

import { Card, LoadingFeedback } from 'components'

import usePhishing from 'hooks/usePhishing'
import useSnackbar from 'hooks/useSnackbar'
import * as service from 'service'

import { RecipientsSelector } from './components'

const ParticipantsStep = () => {
  const [loading, setLoading] = useState(false)
  const [recipientsError, setRecipientsError] = useState('')

  const snackbar = useSnackbar()
  const {
    phishing,
    handleNext,
    isReadOnly,
    wantsToAdvanceStep,
    resetAdvanceStep,
  } = usePhishing()

  const onSubmit = async () => {
    setLoading(true)

    try {
      const hasRecipients =
        (phishing?.recipients || []).length > 0 ||
        (phishing?.externalRecipients || []).length > 0

      if (!hasRecipients) {
        setRecipientsError('Selecione pelo menos 1 participante')
        resetAdvanceStep()
        return
      }

      setRecipientsError('')

      const allInternalParticipants = (phishing?.recipientGroups || []).flatMap(
        (group) =>
          group.users.map((user) => ({
            userId: user.id,
            departmentId: group.id,
          })),
      )

      const seenUserIds = new Set()
      const internalParticipants = allInternalParticipants.filter(
        (participant) => {
          if (seenUserIds.has(participant.userId)) return false
          seenUserIds.add(participant.userId)
          return true
        },
      )

      const externalParticipants = (phishing?.externalRecipients || []).map(
        (recipient) => ({
          email: recipient.email,
          name: recipient.name,
          departmentId: recipient.department?.id,
        }),
      )

      const participants = [...internalParticipants, ...externalParticipants]

      await service.dponet.phishingCampaigns.participantsStep(phishing.id, {
        phishingCampaign: { participants },
      })

      resetAdvanceStep()
      handleNext()
    } catch {
      snackbar.open({
        message: 'Erro ao salvar participantes da campanha.',
        variant: 'error',
      })
      resetAdvanceStep()
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (wantsToAdvanceStep) {
      onSubmit()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wantsToAdvanceStep])

  return (
    <>
      <LoadingFeedback open={loading} />
      <Card>
        <Box p={2}>
          <RecipientsSelector error={recipientsError} disabled={isReadOnly} />
        </Box>
      </Card>
    </>
  )
}

export default ParticipantsStep
